import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TestService } from 'src/app/services/test.service';
import { FormControl } from '@angular/forms';

import {fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';

@Component({
    selector: 'tests-dialog',
    templateUrl: 'tests.component.html',
  })
  export class TestsDialog {

    tests;
    sections;
    profiles
    value;
    list;
    filter = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<TestsDialog>,
        private testService: TestService) {
    

            this.testService.getAllTests().then(
              data => {
                this.tests = data;
                this.filteredTests = data;
                this.sections = [... new Set(data.map(test => test.sectionDescription))]
        
                console.log(this.tests, this.sections)
              }
            )
            this.testService.getAllProfiles().then(
              data => this.profiles = data
            )
            
            this.filter.valueChanges.pipe(debounceTime(300)).subscribe(
              (term) => {
                console.log(term)
                term = term?.toLowerCase();
                this.filteredTests = this.tests.filter(
                  test => {
                    
                    return(
                      test.id?.toLowerCase().includes(term) ||
                      test.description?.toLowerCase().includes(term) ||
                      test.specimenDescription?.toLowerCase().includes(term)
                    )
                  }
                  
                );
              }     
            )         
        }

    clear(){
      this.filter = new FormControl();
    }

    selectedTests = new Array();
    selectTest(test, index){      
      const search = this.selectedTests.findIndex((t) => t.id === test.id);
      if (search === -1) this.selectedTests.push(test)
    }

    removeTest(index){
      this.selectedTests = this.selectedTests.filter(
        (test, i) => i != index
      )
    }

  filteredTests = new Array();

  filterTests(section){
  
      this.filteredTests = this.tests.filter(
        test => test.sectionDescription == section
      );
    
  }

    

  } 